import $ from 'jquery';
import BaseView from '../../core/baseView';
import * as dataTipped from '../../../home24/modules/common/data-tipped';

export default BaseView.extend({
  events: {
    'change [type="radio"]': 'onRadioButtonChange',
    'focus .js-input-b2b-company': 'onInputFocus',
    'change .js-input-b2b-company': 'onInputChange'
  },

  selectors: {
    hiddenInput: '.js-input-b2b-value',
    hiddenInputCustomerCompany: '.js-input-b2b-customer-company',
    input: '.js-input-b2b-company',
    radio: '[type="radio"]',
    inputsetClass: 'js-inputset'
  },

  initialize: function() {
    if (this.$el.hasClass(this.selectors.inputsetClass)) {
      this.$hiddenInput = this.$el.find(this.selectors.hiddenInput);
      this.$input = this.$el.find(this.selectors.input);
      this.$radioGroup = this.$el.find(this.selectors.radio);

      this.model.set({
        customerCompanyValue: this.$el
          .find(this.selectors.hiddenInputCustomerCompany)
          .val(),
        fieldSelected: this.$radioGroup.filter('[checked="checked"]').val(),
        inputValue: this.$input.val(),
        hiddenInputValue: this.$hiddenInput.val()
      });
      this.bindEvents();
      dataTipped.init();
    }
  },

  bindEvents: function() {
    this.listenTo(this.model, 'change:hiddenInputValue', this.onValueChange);
  },

  onRadioButtonChange: function(e) {
    this.model.set('fieldSelected', $(e.target).val());
  },

  onInputFocus: function() {
    this.$radioGroup.filter('[value="input"]').trigger('change');
  },

  onInputChange: function() {
    var value = this.$input.val();

    this.model.set({
      inputValue: value,
      hiddenInputValue: value
    });
  },

  onValueChange: function(model, value) {
    this.$hiddenInput.val(value);
    this.$hiddenInput.valid();
  }
});



/** WEBPACK FOOTER **
 ** ./legacy/home24-desktop/layout/b2b/inputsetB2bCompanyView.js
 **/